import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DriverStatusIconComponent } from './components/driver-status-icon/driver-status-icon.component';
import { IconsModule } from '@fleet-beat/core';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DriverStatusIconComponent],
  imports: [CommonModule, IconsModule, MatIconModule],
  exports: [DriverStatusIconComponent],
})
export class DriverStatusIconModule {}
